import type { FaireProductEntity } from "../../entity_types/product";

export const p_qp2t6hvcdn: FaireProductEntity = {
  token: "p_qp2t6hvcdn",
  type: "product",
  name: "Blue Gingham Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e56ee4dc68b4c77ede15c1621b81813fb268211b51e42d3111e7694d800f387d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/92eb2228de2fd1a1f2a41c79caa194c82ddf8f36d990c4391074f9aa1cd0f23a.jpeg",
    "https://cdn.faire.com/fastly/45fd0e1fb8da8713cb5c48176e4ea0cecf36658bda99d7c60435c5ce9ca76983.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:35.070Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
